import { R$ } from 'shared/helpers/currency';
import { Contract } from 'shared/models/contract';
import ContractDataBox from './ContractDataBox';
import ContractDetailsBlock from './ContractDetailsBlock';

interface ContractMainDataSectionProps {
  loading?: boolean;
  contract: Contract;
}
const ContractMainDataSection = ({
  loading,
  contract,
}: ContractMainDataSectionProps) => {
  return (
    <ContractDetailsBlock>
      <ContractDataBox loading={loading} label="ID">
        {contract.id}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Tipo">
        {contract.selectedPeriodicity}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Valor do contrato">
        {R$(contract.products.reduce((sum, p) => sum + p.value, 0))}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Data de expiração">
        {contract.expiration_date?.format('DD/MM/YYYY')}
      </ContractDataBox>
    </ContractDetailsBlock>
  );
};
export default ContractMainDataSection;
